/* eslint-disable prettier/prettier */
//import { computed } from "vue"
import { useStore } from "vuex"

const modSocial = () =>{
    const store = useStore()


    const getRelatives = async (id_persona) => {
      const resp = await store.dispatch("mod_social/getRelatives", id_persona)
      return resp
     }
    const saveContactPpl =  async (data) => {
      const resp = await store.dispatch("mod_social/saveContactPpl",data)
       return resp
     }
     const saveEditedPplContact =  async (data) => {
      const resp = await store.dispatch("mod_social/saveEditedPplContact",data)
       return resp
     }










     const getAsistenciaPrincipal = async () => {
      const resp = await store.dispatch("mod_social/getAsistenciaPrincipal")
      return resp
     }
     const getSubAsistencia = async (id_principal) => {
      const resp = await store.dispatch("mod_social/getSubAsistencia", id_principal)
      return resp
     }
     const getAsistencia = async (id_sub_asistencia) => {
      const resp = await store.dispatch("mod_social/getAsistencia", id_sub_asistencia)
      return resp
     }
     const savePplAttendance =  async (data) => {
      console.log("data", data);
      const resp = await store.dispatch("mod_social/savePplAttendance",data)
       return resp
     }
     const getPplAttendance = async (id_recinto_penitenciario) => {
      const resp = await store.dispatch("mod_social/getPplAttendance", id_recinto_penitenciario)
      return resp
     }





    const getAreaFormacion = async () => {
        const resp = await store.dispatch("mod_education/getAreaFormacion")
        return resp
   }
   const saveInstitution =  async (data) => {
    const resp = await store.dispatch("mod_education/saveInstitution",data)
     return resp
   }
   const getCourses = async (id_recinto_penitenciario) => {
    const resp = await store.dispatch("mod_education/getCourses", id_recinto_penitenciario)
    return resp
   }
   
   const deleteInstitution =  async (id_institution) => {
    const resp = await store.dispatch("mod_education/deleteInstitution",id_institution)
     return resp
   }
   

   const saveCourse =  async (data) => {
    const resp = await store.dispatch("mod_education/saveCourse",data)
     return resp
   }
   const getInstitutions = async (departamento_centro_penitenciario) => {
    const resp = await store.dispatch("mod_education/getInstitutions", departamento_centro_penitenciario)
    return resp
   }
   const editCourse =  async (data) => {
    const resp = await store.dispatch("mod_education/editCourse",data)
     return resp
   }
   const deleteCourse =  async (id_asignatura) => {
    const resp = await store.dispatch("mod_education/deleteCourse",id_asignatura)
     return resp
   }

   
   const getTeachers = async (id_recinto_penitenciario) => {
    const resp = await store.dispatch("mod_education/getTeachers", id_recinto_penitenciario)
    return resp
   }
   const deleteTeacherById = async (id_profesor) => {
    const resp = await store.dispatch("mod_education/deleteTeacherById", id_profesor)
    return resp
   }
   const deleteTeacherCourseById = async (id_profesor_asignatura, id_profesor) => {
    const resp = await store.dispatch("mod_education/deleteTeacherCourseById", {id_profesor_asignatura, id_profesor})
    return resp
   }


   const saveStudent =  async (data) => {
    const resp = await store.dispatch("mod_education/saveStudent",data)
     return resp
   }
   const getStudents = async (id_recinto_penitenciario) => {
    const resp = await store.dispatch("mod_education/getStudents", id_recinto_penitenciario)
    return resp
   }
   const editStudent =  async (data) => {
    const resp = await store.dispatch("mod_education/editStudent",data)
     return resp
   }
   const deleteStudentById = async (id_estudiante_asignatura) => {
    const resp = await store.dispatch("mod_education/deleteStudentById", id_estudiante_asignatura)
    return resp
   }






    return{
      getRelatives,



      saveContactPpl,
      getAsistenciaPrincipal,
      getSubAsistencia,
      getAsistencia,
      savePplAttendance,
      getPplAttendance,

        getAreaFormacion,
        saveInstitution,
        getInstitutions,
        saveEditedPplContact,
        deleteInstitution,

        saveCourse,
        getCourses,
        editCourse,
        deleteCourse,

        getTeachers,
        deleteTeacherById,
        deleteTeacherCourseById,

        saveStudent,
        getStudents,
        editStudent,
        deleteStudentById,
    }
    
};

export default modSocial